import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { compose } from 'react-recompose';
import { withRouter } from 'react-router-dom';
import { Breakpoint } from 'react-socks';

import { EmptyList, Pagination, withAmplitude } from 'modules/common';
import TeamListBodyDesktop from './list-body/desktop.component';
import TeamListBodyMobile from './list-body/mobile.component';
import { navigateOrTabToItem } from 'modules/common/navigateToItem.tools';
import { Link } from 'react-router-dom';

function TeamPagesListBody({ history, match, pages, onChangeFilter }) {
  const { current_page, page_count, total_count, results } = pages;
  const navigateToItem = (uuid, event) => navigateOrTabToItem(history, event, `${match.url}/${uuid}`);

  if (!results || results.length === 0) {
    return (
      <>
        <EmptyList
          text="No Team Pages"
          description="Create a page to start raising money for your favorite candidates and committees!"
          buttonText="Create Team Page"
          icon="donate"
          name="page"
          as={Link}
          to={'/team-pages/pages/new'}
        />
      </>
    );
  }

  return (
    <>
      <Breakpoint small down>
        <TeamListBodyMobile items={results} match={match} />
      </Breakpoint>
      <Breakpoint medium up>
        <TeamListBodyDesktop items={results} navigateToItem={navigateToItem} />
      </Breakpoint>
      <Pagination currentPage={current_page} pageCount={page_count} totalCount={total_count} setPage={onChangeFilter} />
    </>
  );
}

TeamPagesListBody.propTypes = {
  pages: PropTypes.object.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default compose(withRouter, withAmplitude)(TeamPagesListBody);
